/*
 * Purpose : Main Landing page for the application.
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React, {useState, useContext} from 'react';
import { CardFooter, CardBody, CardText, CardTitle , Card, CardDeck, Alert } from 'reactstrap';
import { useHistory } from "react-router-dom";
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import CardActionArea from '@material-ui/core/CardActionArea';
import ButtonM from '@material-ui/core/Button';
//import { NavLink } from 'react-router-dom';

import Aux from '../../hoc/Auxilliary/Auxilliary';
import formIcon from '../../assets/form-icon.jpg';
import formIcon2 from '../../assets/form-icon-2.png';
import SetupLogo from '../../assets/setup.jpg';
import Dashboardlogo from '../../assets/dashboard-icon-5.gif';
import AlertModal from './../UI/modals/alertModal';
import AppContext from './../../context/app-context';
//amplify conf
import LoadingModal from '../UI/modals/loadingModal';


const Home = (props) => {
    const useStyles = makeStyles((theme) => ({
        root: {
          flexGrow: 1,          
        },
        paper: {
          height: 100,
          width: 100,
        },
        control: {
          padding: theme.spacing(2),
        },
        cardDeck: {
            align:"center", 
            //margin:"5% 5%"
            marginTop:"2%",
            marginRight:"5%",
            marginBottom:"2%",
            marginLeft:"5%",
            // display:"flex",
            // flexWrap:"wrap",
            justifyContent: "space-evenly",
            
        },
        card: {
            borderRadius: "8px",
            //boxShadow: "6px 8px 8px 8px #C0C0C0",
            boxShadow: "6px 6px 6px 6px #E0E0E0",//rgba(60, 61, 65, 0.05)",
            //padding:"1em",
            textAlign: "center",
            //width: "257px"
            border:"0px solid rgba(0,0,0,.125)",
            //height:"360px",
            //width: "85%",
            minWidth:"auto",
            marginBottom:"15px !important",
            //justifyContent: "center",

        },
        cardActionArea: {
            align:"center",
            marginTop:"10px !important",
            // marginBottom:"50px"
        },
        cardBody:{
            minHeight:"100px",
            marginBottom:"20%",
            padding:"2%",
            [theme.breakpoints.up("sm")]: {
                minHeight:"180px",
                marginBottom:"20%",
                padding:"2%",
              },
        },
        cardAction: {
            alignSelf: "center",
            position:"absolute",
            bottom:"0",
            width:"-webkit-fill-available"
        },
        image: {
            borderRadius: "20%",
            width:"100px",
            height:"100px",
            marginBottom:"10%"
        },
      }));

      const classes = useStyles();

      //using context api in functional component
      const appContext = useContext(AppContext)
      let history = useHistory();

      const [alertModal, setAlertModal] = useState(false)
      const [error, setError] = useState(null)
      const [loading, setLoading] = useState(false)
      //console.log("Home Component imported")

    //   const getUserRoles = async() => {
    //     console.log("props.user=>",props.user);
    //     try {
    //         const q = `query 
    //         {
    //             listExcessuserroless(limit:${process.env.REACT_APP_USERROLES_TABLE_LIMIT}, filter: {id: {eq: "${props.user}" }}) {
    //                 items {
    //                 role
    //                 }
    //             }
    //         }`;
    //         const apiData =await API.graphql(graphqlOperation(q))
    //         const results = apiData.data.listExcessuserroless.items;            
    //         console.log("data fetched")
    //         return results
    //     } catch (error) {
    //         const reqBody = {
    //             level:"error",
    //             message: "Error while fetching the user roles data in home component. error: "+JSON.stringify(error)
    //         }
    //         axios.post( `${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
    //                         reqBody,
    //                         { headers: {'x-api-key':process.env.REACT_APP_REST_API_KEY} }
    //                     );
    //         setError("Error while fetching the user roles data")            
    //     }
    // }

    // check for the login user role and redirect
    const checkUserRole = async (path) => {
                
        //console.log("appContext?.role=>",appContext.role)
        appContext.role === "Admin"
        ? history.push(path) 
        : ( path==="/retirementform" )
        ? history.push(path)
        : ( path==="/toolsalesform" && (appContext?.role?.indexOf("Tool Sales")!== -1 || appContext?.role ==="Common Viewer") )
        ? history.push(path)
        // : ( path==="/retirementform" && (appContext?.role?.indexOf("Tool Sales") === -1) )
        // ? history.push(path)
        : setAlertModal(true)
        
        //old approach without using useHistory and context api
        // console.log("setLoading=>",loading)        
        // setLoading(true)
        // let userRole = await getUserRoles()
        // console.log("userRole home=>",userRole)
        // if(userRole){
        //     setLoading(false)
        //     if(userRole.length !== 0 && userRole[0].role === 'Admin'){
        //         //window.location.href = path
        //         history.push(path);
        //    }else{
        //        setAlertModal(true)
        //        //alert("You do not have rights to access this page")
        //    }
        // }
    }
    return(
        <Aux>
            {/* <Header username={props.user} home={true}></Header> */}
            <Alert color="danger" isOpen={error}>{error}</Alert>
            <AlertModal open={alertModal} msg="You do not have rights to access this page.!" handler={setAlertModal}/>
            <LoadingModal open={loading} msg="Checking User rights..." />
            <Grid container className={classes.root}>
                <CardDeck className={classes.cardDeck}>                
                <Card className={classes.card}>
                     {/* <NavLink style={{ textDecoration: 'none',color: 'black' }} to='/retirementform' exact> */}
                        {/* <CardActionArea className={classes.cardActionArea} onClick={ () => window.location.href = `/retirementform` }> */}
                        <CardActionArea className={classes.cardActionArea} onClick={ ()=>checkUserRole('/retirementform') }>
                            <span>
                                <img src={formIcon} alt="logo" className={classes.image} />
                            </span>
                            {/* <CardContent>
                            <Typography gutterBottom variant="h5" component="h5">
                                Tool Declaration Form
                            </Typography>
                            <Typography variant="inherit" color="textSecondary" component="subtitle2">
                                Create/View form
                            </Typography>
                            </CardContent> */}
                        </CardActionArea>
                        {/* </NavLink> */}
                        <CardBody className={classes.cardBody}>
                            <CardTitle tag="h5">Tool Declaration Form</CardTitle>
                            <CardText>Create/Edit/View/Delete tool declaration form</CardText>
                        </CardBody>                    
                        <CardFooter className={classes.cardAction}>
                            {/* <NavLink style={{ textDecoration: 'none' }} to='/retirementform' exact> */}
                            <ButtonM  size="large"  style={{color:"#337ab7"}} onClick={ ()=>checkUserRole('/retirementform') }>
                                <h5><b>Form</b></h5>
                            </ButtonM>
                            {/* </NavLink> */}
                            
                            {/* <NavLink
                                to='/transactions'
                                exact>List
                            </NavLink> */}
                            {/* <ButtonM size="small" color="primary">
                            Learn More
                            </ButtonM> */}
                        </CardFooter>
                    </Card>
                    <Card className={classes.card}>
                        {/* <NavLink style={{ textDecoration: 'none',color: 'black' }} to='/toolsalesform' exact> */}
                        {/* <CardActionArea className={classes.cardActionArea} onClick={ () => window.location.href = `/toolsalesform` }> */}
                        <CardActionArea className={classes.cardActionArea} onClick={ ()=>checkUserRole('/toolsalesform') }>
                            <span>
                                <img src={formIcon2} alt="logo" className={classes.image} />
                            </span>
                            {/* <CardContent>
                            <Typography gutterBottom variant="h5" component="h5">
                                Tool Sales Transaction Form
                            </Typography>
                            <Typography variant="inherit" color="textSecondary" component="subtitle2">
                                Create/View form
                            </Typography>
                            </CardContent> */}
                        </CardActionArea>
                        {/* </NavLink> */}
                        <CardBody className={classes.cardBody}>
                            <CardTitle tag="h5">Tool Sales Transaction Form</CardTitle>
                            <CardText>Create/Edit/View/Delete tool sale transaction form</CardText>
                        </CardBody>                        
                        <CardFooter className={classes.cardAction}>
                            {/* <NavLink style={{ textDecoration: 'none' }} to='/toolsalesform' exact> */}
                            <ButtonM  size="large"  style={{color:"#337ab7"}} onClick={()=>checkUserRole('/toolsalesform')} >
                                <h5><b>Form</b></h5>
                            </ButtonM>
                            {/* </NavLink> */}
                            {/* <ButtonM size="small" color="primary">
                            Learn More
                            </ButtonM> */}
                        </CardFooter>
                    </Card>                    
                    <Card className={classes.card}>
                        <CardActionArea className={classes.cardActionArea} onClick={ ()=>checkUserRole('/dashboard') }>
                            <span>
                                <img src={Dashboardlogo} alt="dashboard logo" className={classes.image} />
                            </span>
                            {/* <CardContent>
                            <Typography gutterBottom variant="h5" component="h5">
                                Dashboard
                            </Typography>
                            <Typography variant="inherit" color="textSecondary" component="subtitle2">
                                View Dashboard
                            </Typography>
                            </CardContent> */}
                        </CardActionArea>
                        <CardBody className={classes.cardBody}>
                            <CardTitle tag="h5">Dashboard</CardTitle>
                            <CardText>View Tool status charts, Application logs</CardText>
                        </CardBody>
                        <CardFooter className={classes.cardAction}>
                            <ButtonM  size="large"  style={{color:"#337ab7"}} onClick={()=>checkUserRole('/dashboard')} >
                                <h5><b>View</b></h5>
                            </ButtonM>
                        </CardFooter>
                    </Card>
                    <Card className={classes.card}>
                        <CardActionArea className={classes.cardActionArea} onClick={ ()=>checkUserRole('/setup') }>
                            <span>
                                <img src={SetupLogo} alt="user logo" className={classes.image} />
                            </span>
                            {/* <CardContent>
                            <Typography gutterBottom variant="h5" component="h5">
                                Setup
                            </Typography>
                            <Typography variant="inherit" color="textSecondary" component="subtitle2">
                                Configuration, user setup etc.
                            </Typography>
                            </CardContent> */}
                        </CardActionArea>
                        <CardBody className={classes.cardBody}>
                            <CardTitle tag="h5">Setup</CardTitle>
                            <CardText>Configure Locations, Users, Brokers etc.</CardText>
                        </CardBody>
                        <CardFooter className={classes.cardAction}>
                            <ButtonM  size="large"  style={{color:"#337ab7"}} onClick={()=>checkUserRole('/setup')} >
                                <h5><b>Setup</b></h5>
                            </ButtonM>
                        </CardFooter>
                    </Card>                              
                </CardDeck>            
            </Grid>
        </Aux>
    );
}
export default Home;